export const CHANGE_NEWS_LIST = 'news/CHANGE_NEWS_LIST'
export const CHANGE_NEWS_DETAIL = 'news/CHANGE_NEWS_DETAIL'
